export default __webpack_public_path__ + "static/media/schedule-maintenance-inactive.6c8d4128.svg";